<!--
   The MIT License

   Copyright (c) 2019- Nordic Institute for Interoperability Solutions (NIIS)
   Copyright (c) 2018 Estonian Information System Authority (RIA),
   Nordic Institute for Interoperability Solutions (NIIS), Population Register Centre (VRK)
   Copyright (c) 2015-2017 Estonian Information System Authority (RIA), Population Register Centre (VRK)

   Permission is hereby granted, free of charge, to any person obtaining a copy
   of this software and associated documentation files (the "Software"), to deal
   in the Software without restriction, including without limitation the rights
   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   copies of the Software, and to permit persons to whom the Software is
   furnished to do so, subject to the following conditions:

   The above copyright notice and this permission notice shall be included in
   all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   THE SOFTWARE.
 -->
<template>
  <g>
    <path
      d="M12.9091 6.59091C12.9091 5.77827 13.0868 5.00713 13.4055 4.31424L12 2.95459L10.2013 4.69287L7.72621 4.34308L7.29297 6.80757L5.08416 7.97945L6.18146 10.2273L5.08416 12.4752L7.29297 13.6471L7.72621 16.1116L10.2031 15.7618L12 17.5L13.7987 15.7618L16.2756 16.1116L16.707 13.6471L18.9176 12.4752L18.7024 12.0351C18.5904 12.042 18.4774 12.0455 18.3636 12.0455C15.3512 12.0455 12.9091 9.60337 12.9091 6.59091Z"
      fill="#211E1E"
    />
    <path
      d="M5.62038 14.7888L2 18.4091L4.72727 19.3182L5.63636 22.0455L9.80895 17.8729L9.58523 17.6598L8.47017 17.8161C8.36108 17.8316 8.25429 17.8392 8.14702 17.8392C7.02338 17.8392 6.06615 17.035 5.87251 15.9287L5.67898 14.8207L5.62038 14.7888Z"
      fill="#211E1E"
    />
    <path
      d="M18.3796 14.7888L18.321 14.8207L18.1275 15.9287C17.9329 17.0359 16.9766 17.8392 15.853 17.8392C15.7457 17.8392 15.6389 17.8316 15.5298 17.8161L14.4148 17.6598L14.1911 17.8747L18.3636 22.0455L19.2727 19.3182L22 18.4091L18.3796 14.7888Z"
      fill="#211E1E"
    />
    <path d="M17.4545 5.68186V2.95459H19.2727V5.68186H22V7.50004H19.2727V10.2273H17.4545V7.50004H14.7273V5.68186H17.4545Z" fill="#211E1E" />
    <path d="M17.4545 5.68186V2.95459H19.2727V5.68186H22V7.50004H19.2727V10.2273H17.4545V7.50004H14.7273V5.68186H17.4545Z" fill="#0CC177" />
  </g>
</template>
